const common = {
  brand: "USFansSheet",
  nav: {
    home: "Accueil",
    shopGuide: "Guide d'achat",
    categories: "Catégories",
    resources: "Ressources",
    guides: "Guides",
    safety: "Sécurité",
    faq: "FAQ",
  },
  languages: {
    en: "English",
    pl: "Polski",
    es: "Español",
    fr: "Français",
  },
  footer: {
    tagline: "Un centre de ressources indépendant pour la recherche, les guides et les conseils de sécurité sur le tableau USFans.",
    navTitle: "Explorer",
    categoriesTitle: "Catégories",
    disclaimer: "USFansSheet.live est une ressource informative indépendante. Il n'est pas nécessairement affilié à, exploité par ou approuvé par USFans. Les informations peuvent changer et doivent être vérifiées de manière indépendante avant tout achat, paiement ou décision de compte.",
    rights: "Tous droits réservés.",
  },
};

export default common;